"use strict";

var _interopRequireWildcard = require("@babel/runtime/helpers/interopRequireWildcard");

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _objectSpread2 = _interopRequireDefault(require("@babel/runtime/helpers/esm/objectSpread2"));

var _react = _interopRequireWildcard(require("react"));

var _antd = require("antd");

var _reactApexcharts = _interopRequireDefault(require("react-apexcharts"));

var _ChartConstant = require("../../../constants/ChartConstant");

var _reactResizeDetector = _interopRequireDefault(require("react-resize-detector"));

var titleStyle = {
  position: 'absolute',
  zIndex: '1'
};
var extraStyle = {
  position: 'absolute',
  zIndex: '1',
  right: '0',
  top: '-2px'
};

var getChartTypeDefaultOption = function getChartTypeDefaultOption(type) {
  switch (type) {
    case 'line':
      return _ChartConstant.apexLineChartDefaultOption;

    case 'bar':
      return _ChartConstant.apexBarChartDefaultOption;

    case 'area':
      return _ChartConstant.apexAreaChartDefaultOption;

    default:
      return _ChartConstant.apexLineChartDefaultOption;
  }
};

var ChartWidget = function ChartWidget(_ref) {
  var title = _ref.title,
      series = _ref.series,
      width = _ref.width,
      height = _ref.height,
      xAxis = _ref.xAxis,
      customOptions = _ref.customOptions,
      card = _ref.card,
      type = _ref.type,
      extra = _ref.extra;
  var options = getChartTypeDefaultOption(type);
  var isMobile = window.innerWidth < 768;

  var setLegendOffset = function setLegendOffset() {
    if (chartRef.current) {
      var _extraRef$current;

      var lengend = chartRef.current.querySelectorAll('div.apexcharts-legend')[0];
      lengend.style.marginRight = "".concat(isMobile ? 0 : (_extraRef$current = extraRef.current) === null || _extraRef$current === void 0 ? void 0 : _extraRef$current.offsetWidth, "px");

      if (isMobile) {
        lengend.style.position = 'relative';
        lengend.style.top = 0;
        lengend.style.justifyContent = 'start';
        lengend.style.padding = 0;
      }
    }
  };

  (0, _react.useEffect)(function () {
    setLegendOffset(); // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);
  var extraRef = (0, _react.useRef)(null);
  var chartRef = (0, _react.useRef)();
  options.xaxis.categories = xAxis;

  if (customOptions) {
    options = (0, _objectSpread2.default)((0, _objectSpread2.default)({}, options), customOptions);
  }

  var onResize = function onResize() {
    setTimeout(function () {
      setLegendOffset();
    }, 600);
  };

  var renderChart = /*#__PURE__*/_react.default.createElement(_reactResizeDetector.default, {
    onResize: onResize()
  }, /*#__PURE__*/_react.default.createElement("div", {
    className: "chartRef",
    ref: chartRef
  }, /*#__PURE__*/_react.default.createElement(_reactApexcharts.default, {
    options: options,
    type: type,
    series: series,
    width: width,
    height: height
  })));

  return /*#__PURE__*/_react.default.createElement(_react.default.Fragment, null, card ? /*#__PURE__*/_react.default.createElement(_antd.Card, null, /*#__PURE__*/_react.default.createElement("div", {
    className: "position-relative"
  }, /*#__PURE__*/_react.default.createElement("div", {
    style: !isMobile ? titleStyle : {}
  }, title) && /*#__PURE__*/_react.default.createElement("h4", {
    className: "font-weight-bold",
    style: !isMobile ? titleStyle : {}
  }, title), extra && /*#__PURE__*/_react.default.createElement("div", {
    ref: extraRef,
    style: !isMobile ? extraStyle : {}
  }, extra), renderChart)) : renderChart);
};

ChartWidget.defaultProps = {
  series: [],
  height: 300,
  width: '100%',
  card: true,
  type: 'line'
};
var _default = ChartWidget;
exports.default = _default;